var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", { class: _vm.iconClass }, [_vm._v(_vm._s(_vm.data.type))])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }